import React from "react";
import { Link } from "react-router-dom";
import { Home as HomeIcon, Wine, FileText, MapPin, Phone, ArrowRight } from "lucide-react";
import { SEO } from "../components/SEO";

const POPULAR = [
    { to: "/spirits", icon: Wine, label: "Browse Spirits" },
    { to: "/blog", icon: FileText, label: "Read the Blog" },
    { to: "/visit", icon: MapPin, label: "Visit the Store" },
    { to: "/contact", icon: Phone, label: "Contact Us" },
];

export default function NotFound() {
    return (
        <>
            <SEO
                title="Page Not Found"
                description="That page doesn't exist — but our shelves still do. Browse spirits, recipes, or visit Liquor Studio in Clinton, MO."
                path="/404"
                noindex
            />

            <section
                className="flex items-center justify-center"
                style={{ minHeight: "82vh", paddingTop: 110, paddingBottom: 80 }}
                data-testid="notfound-section"
            >
                <div className="ls-container text-center max-w-2xl">
                    <p
                        className="font-bebas"
                        style={{ color: "var(--ls-gold)", fontSize: 112, lineHeight: 1, letterSpacing: "0.04em" }}
                        aria-hidden="true"
                    >
                        404
                    </p>
                    <h1
                        className="font-display text-white mt-4"
                        style={{
                            fontSize: "clamp(36px, 5vw, 56px)",
                            fontWeight: 500,
                            lineHeight: 1.05,
                            letterSpacing: "-0.02em",
                        }}
                    >
                        That bottle <em style={{ fontStyle: "italic", color: "var(--ls-gold)", fontWeight: 400 }}>isn't on our shelf.</em>
                    </h1>
                    <p
                        className="mt-5"
                        style={{ color: "var(--ls-text-secondary)", fontSize: 17, lineHeight: 1.7 }}
                    >
                        The page you're looking for doesn't exist — or maybe we sold the last one.
                        Try one of these instead.
                    </p>

                    <div
                        className="mt-10 grid grid-cols-2 gap-3"
                        style={{ maxWidth: 460, marginLeft: "auto", marginRight: "auto" }}
                        data-testid="notfound-popular"
                    >
                        {POPULAR.map(({ to, icon: Icon, label }) => (
                            <Link key={to} to={to}
                                className="btn-ghost"
                                style={{ padding: "14px 18px", fontSize: 13, justifyContent: "flex-start", borderRadius: 6 }}
                                data-testid={`notfound-link-${to.replace(/[^a-z]+/gi, "")}`}>
                                <Icon size={14} /> {label} <ArrowRight size={12} style={{ marginLeft: "auto" }} />
                            </Link>
                        ))}
                    </div>

                    <Link to="/" className="btn-primary mt-8" data-testid="notfound-home-cta" style={{ padding: "12px 22px", fontSize: 13 }}>
                        <HomeIcon size={14} /> Back to Home
                    </Link>
                </div>
            </section>
        </>
    );
}
